import "./TransporterCheck.scss";

import React from "react";
import { inject, observer } from "mobx-react";
import { RouteNode } from "react-router5";

import Frame from "../Frame/Frame";
import Popup from "../../Components/Popup/Popup";
import Button from "../../Components/Button/Button";

import { STORE_CONFIG } from "../../Store/ConfigStore";
import {
  ROUTE_TRANSPORTER_CHECK,
  ROUTE_TRANSPORTER_CHECK_DETAILS,
} from "../../routes";
import { STORE_TRANSPORTER_CHECK } from "../../Store/TransporterCheckStore";
import { STORE_AUTH } from "../../Store/AuthStore";

import DatePicker, { registerLocale } from "react-datepicker";
import hu from "date-fns/locale/hu";
registerLocale("hu", hu);

import XLSX from "xlsx";

import {
  formatDate,
  formatDateOnly,
  fixFloat,
  formatNumber,
} from "../../utility";

import Select from "react-select";
import { SelectStyle, DropdownIndicator } from "../App/select_style";

@inject((stores) => ({
  store: stores.store.get(STORE_TRANSPORTER_CHECK),
  configStore: stores.store.get(STORE_CONFIG),
  authStore: stores.store.get(STORE_AUTH),
  socket: stores.socket,
  router: stores.router,
}))
@observer
class TransporterCheckDetails extends React.Component {
  constructor(props) {
    super(props);

    const pallet = props.store.selectedTransporter;
    const bin = props.configStore.bins.find((b) => b.name === pallet.BinCode);

    this.state = {
      popup: "none",
      popupText: "",
      itemselector: false,
      addressselector: null,
      saving: false,
      bin: bin ? { value: bin.id, label: bin.name } : null,
      level: pallet.Level,
      palletId: pallet.Id,
      suggestedBins: [],
    };

    const _this = this;
    props.socket.emitWithToken(
      "GetTransporterSuggestedBins",
      { TransporterId: pallet.Id },
      function (err, data) {
        if (err) {
          console.error(err);
          return;
        }
        _this.setState({ suggestedBins: data });
      }
    );
  }

  componentDidMount() {
    const { route, store } = this.props;
    if (route.params.hasOwnProperty("editedId")) {
      store.setEditedId(route.params.editedId);
    }
  }

  showPopup = (text) => {
    this.setState({ popup: "result", popupText: text });
  };

  save = () => {
    const { store, socket, router } = this.props;

    const _this = this;
    this.setState({ saving: true });
    socket.emitWithToken(
      "CheckTransporter",
      {
        TransporterId: this.state.palletId,
        BinId: this.state.newbin,
        Level: this.state.newlevel,
      },
      function (err, data) {
        if (err) {
          console.error(err);
          _this.showPopup(err);
          _this.setState({ saving: false });
        } else {
          router.navigate(ROUTE_TRANSPORTER_CHECK, { back: true });
          store.setSelectedTransporterId(null);
        }
      }
    );
  };

  back = () => {
    const { store, router } = this.props;
    store.setSelectedTransporterId(null);
    router.navigate(ROUTE_TRANSPORTER_CHECK, { back: true });
  };

  render() {
    const { store, configStore, authStore, route, router, socket } = this.props;
    const pallet = store.selectedTransporter;

    let bin = this.state.bin;
    let levels = null;
    if (bin && bin.levelnum > 1) {
      levels = [];
      for (let i = 0; i < bin.levelnum; i++) {
        levels.push({ value: i, label: i });
      }
      //this.setState({ levels: levels });
    }

    return (
      <Frame>
        <div className="table basic-content">
          <div className="table__top">
            <div className="table__top-backpanel">
              <Button className="task__editbutton" onClick={() => this.back()}>
                Vissza
              </Button>
              <div className="table__top-pagename">
                {(store.type === "raw" ? "Nyers" : "Feldolgozott") +
                  " áru minőség részletek"}
              </div>
            </div>

            <div className="table__top-backpanel">
              {
                <Button
                  className="task__editbutton"
                  disabled={this.state.saving}
                  onClick={() => this.save()}
                >
                  Ellenőrzés véglegesítése
                </Button>
              }
            </div>
          </div>
          <div className="masterdata_form_frame">
            <div className="masterdata_form">
              <div className="formfield">
                <div className="formfield_label">Azonosító</div>
                <div className="formfield_input">
                  <span className="formfield_input-label">
                    <span
                      className={
                        (pallet.CleaningCount > 1 ? "bold" : "normal") +
                        (!pallet.ThisSeason ? " offseasonpallet" : "")
                      }
                    >
                      {pallet.LotNo}
                    </span>
                    {pallet.SealNum ? <br /> : null}{" "}
                    {pallet.SealNum ? "(" + pallet.SealNum + ")" : ""}
                  </span>
                </div>
              </div>
              <div className="formfield">
                <div className="formfield_label">Gép</div>
                <div className="formfield_input">
                  <span className="formfield_input-label">
                    {pallet.MachineText} {pallet.Dressing ? <br /> : null}{" "}
                    {pallet.Dressing ? "(" + pallet.Dressing + ")" : null}
                  </span>
                </div>
              </div>
              <div className="formfield">
                <div className="formfield_label">Fok</div>
                <div className="formfield_input">
                  <span className="formfield_input-label">
                    {pallet.CleaningRateText +
                      (pallet.CustomCleaningRate
                        ? " (" + pallet.CustomCleaningRate + ")"
                        : "")}
                  </span>
                </div>
              </div>
              <div className="formfield">
                <div className="formfield_label">Beszállító</div>
                <div className="formfield_input">
                  <span className="formfield_input-label">
                    {pallet.Supplier +
                      (pallet.CustomSupplier
                        ? " (" + pallet.CustomSupplier + ")"
                        : "")}
                  </span>
                </div>
              </div>
              <div className="formfield">
                <div className="formfield_label">Cikk</div>
                <div className="formfield_input">
                  <span className="formfield_input-label">
                    {pallet.ItemName} {pallet.CustomItem ? <br /> : null}{" "}
                    {pallet.CustomItem ? "(" + pallet.CustomItem + ")" : ""}
                  </span>
                </div>
              </div>
              <div className="formfield">
                <div className="formfield_label">Hely</div>
                <div className="formfield_input checkdetails-selects">
                  <Select
                    className="react-select select-wide-dropdown checkdetails-select"
                    options={configStore.bins.map((bin) => ({
                      value: bin.id,
                      label: bin.name,
                    }))}
                    onChange={(e) => {
                      let bin = configStore.bins.find((b) => b.id === e.value);
                      let levels = null;
                      console.log(bin);
                      if (bin && bin.levelnum && bin.levelnum > 1) {
                        levels = [];
                        for (let i = 0; i < bin.levelnum; i++) {
                          levels.push({ value: i, label: i });
                        }
                      }

                      console.log(configStore.bins, bin, levels);

                      this.setState({
                        bin: e,
                        level: null,
                        levels: levels,
                        newbin: bin.id,
                      });
                    }}
                    value={this.state.bin}
                    isSearchable={true}
                    styles={SelectStyle}
                    components={{ DropdownIndicator }}
                    placeholder="Hely"
                  />
                  {(this.state.levels ||
                    (this.state.levels === undefined && levels)) && (
                    <Select
                      className="react-select checkdetails-select-levels"
                      options={
                        this.state.levels === undefined
                          ? levels
                          : this.state.levels
                      }
                      onChange={(e) => this.setState({ level: e, newlevel: e })}
                      value={this.state.levels ? this.state.level : null}
                      isSearchable={false}
                      styles={SelectStyle}
                      components={{ DropdownIndicator }}
                      placeholder="Szint"
                    />
                  )}
                </div>
              </div>
              <div className="formfield">
                <div className="formfield_label">Automata pozicionálás</div>
                <div className="formfield_input">
                  <span className="formfield_input-label">
                    {pallet.AutoBinCode}
                  </span>
                </div>
              </div>
              <div className="formfield">
                <div className="formfield_label">Mennyiség</div>
                <div className="formfield_input">
                  <span className="formfield_input-label">
                    {(pallet.BagType === 2
                      ? pallet.BagCount + " x " + pallet.Quantity
                      : pallet.Quantity) + " kg"}
                  </span>
                </div>
              </div>
              <div className="formfield">
                <div className="formfield_label">Létrehozva</div>
                <div className="formfield_input">
                  <span className="formfield_input-label">
                    {pallet.Created}
                  </span>
                </div>
              </div>
              <div className="formfield">
                <div className="formfield_label">Állapot</div>
                <div className="formfield_input">
                  <span className="formfield_input-label">
                    {pallet.Checked}
                  </span>
                </div>
              </div>
            </div>

            <div className="masterdata_form">
              <div className="formfield">
                <div className="formfield_label">Javasolt tárhelyek</div>
              </div>

              <div className="formfield">
                <div className="formfield_label">Automata pozicionálás</div>
                <div className="formfield_input">
                  <span className="formfield_input-label">
                    {pallet.AutoBinCode}
                  </span>
                </div>
              </div>

              <div className="formfield">
                <div className="formfield_label">Cikk tárhelyei</div>

                <div className="formfield_input">
                  {this.state.suggestedBins.map((bin) => (
                    <span className="formfield_input-label">
                      {bin.BinCode + (bin.Level ? `/${bin.Level}` : "")}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {(this.state.popup === "error" || this.state.popup === "result") && (
          <Popup
            key="popup"
            text={this.state.popupText}
            buttons={[
              <Button
                className="popup_button"
                onClick={(e) => {
                  this.setState({ popup: "none" });
                  if (this.state.popup === "error") this.back();
                }}
              >
                Ok
              </Button>,
            ]}
            onClickClose={() => {
              this.setState({ popup: "none" });
              if (this.state.popup === "error") this.back();
            }}
          />
        )}
        {this.state.popup === "delete" && (
          <Popup
            key="popup"
            text="Biztosan törli?"
            buttons={[
              <Button
                className="popup_button"
                onClick={() => {
                  this.setState({ popup: "none" });
                  this.delete();
                }}
              >
                Igen
              </Button>,
              <Button
                className="popup_button"
                onClick={(e) => {
                  this.setState({ popup: "none" });
                }}
              >
                Mégse
              </Button>,
            ]}
            onClickClose={() => this.setState({ popup: "none" })}
          />
        )}
      </Frame>
    );
  }
}

export default (props) => (
  <RouteNode nodeName={ROUTE_TRANSPORTER_CHECK_DETAILS}>
    {(routeProps) => <TransporterCheckDetails {...routeProps} {...props} />}
  </RouteNode>
);
